export const convertWordToSentenceCase = (word: string) => {
	return `${word[0].toUpperCase()}${word.substring(1).toLowerCase()}`;
};

export function convertTextToSlug(text: string): string {
	return text
		.toLowerCase()
		.replace(/\s/g, '-')
		.replace(/[^a-z0-9-]/g, '');
}
